import { render, staticRenderFns } from "./EquiposTecnicos.vue?vue&type=template&id=a6d5e30e&"
import script from "./EquiposTecnicos.vue?vue&type=script&lang=js&"
export * from "./EquiposTecnicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports